import React, { useEffect, useState, useCallback, use } from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';
import Select from 'react-select';

import { storageKeys } from 'settings';
import { StorageHandler, APIHandler, DataHandler } from 'C4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDropzone } from 'react-dropzone';

function BookingForm(props) {
  const [logo, setLogo] = useState(null);
  const [showIframe, setShowIframe] = useState(false);
  const [agentFirstName, setAgentFirstName] = useState('');
  const [agentLastName, setAgentLastName] = useState('');
  const [agentCompany, setAgentCompany] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [agentCity, setAgentCity] = useState('');
  const [agentCountry, setAgentCountry] = useState('');
  const [agentId, setAgentId] = useState('');
  const [userInfo, setUserInfo] = useState({});
  const [fileUrl, setFileUrl] = useState(null);
  const [isUk, setIsUk] = useState(false);
  const [isAus, setIsAus] = useState(false);
  const [isFr, setIsFr] = useState(false);
  const [isDe, setIsDe] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedAccommodations, setSelectedAccommodations] = useState([]);
  const [selectedTourOperators, setSelectedTourOperators] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [customAccommodation, setCustomAccommodation] = useState('');
  const [customOperator, setCustomOperator] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);

  function DropZone() {
    const onDrop = useCallback((acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();

        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => console.log('file reading has failed');
        reader.onload = () => {
          const binaryStr = reader.result;

          // Check file size max 100mb
          if (file.size > Math.pow(10, 6) * 100) {
            // Show toast
            toast.error(i18n.translate('general.fileSizeError'), {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            return;
          }

          // Upload file to server and set progress bar
          const data = {
            name: file.name,
            type: file.type,
            size: file.size,
            url: binaryStr,
          };
          StorageHandler.load(storageKeys.accessToken).then((token) => {
            APIHandler.uploadFile(data, token).then((response) => {
              // Set file url to state
              console.log(response);
              setFileUrl(response.path);
              props.handleChangeFile(response.path);
            });
          });
        };

        reader.readAsDataURL(file);
      });
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
      accept: {
        'image/jpeg': [],
        'image/png': [],
        'application/pdf': [],
      },
      onDrop,
    });

    return (
      <section className="container">
        <div {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />

          <p>{i18n.translate('rewards.bookingForm.dropzone')}</p>
          <em>{i18n.translate('rewards.bookingForm.dropzoneAcceptedFiles')}</em>
        </div>
      </section>
    );
  }

  const getAppInfo = async () => {
    const appId = await DataHandler.matchAppId();
    const appInfo = await APIHandler.getAppInfo(appId);
    setLogo(appInfo.app[0].logo);
  };

  const getUserInfo = async () => {
    if (!props.agentEmail) {
      return;
    }

    const newUser = await APIHandler.getUserRewards(props.agentEmail);
    if (newUser) {
      setAgentFirstName(newUser.response.first_name);
      setAgentLastName(newUser.response.last_name);
      setAgentCompany(newUser.response.agency_name);
      setPostalCode(newUser.response.zip_code);
      setAgentCity(newUser.response.city);
      setAgentId(newUser.response.id_number);
      setAgentCountry(newUser.response.country);
      setUserInfo(newUser.response);
    }
  };

  const closeIframe = () => {
    setShowIframe(false);

    // Reload user info
    getUserInfo();
  };

  const openFancybox = () => {
    setShowIframe(true);
  };

  useEffect(() => {
    getAppInfo();
    if (Object.keys(userInfo).length === 0) {
      getUserInfo();
    }
  }, [userInfo, props.agentEmail]);

  const {
    airline,
    accomodationName,
    arrivalDate,
    departureDate,
    submitForm,
    handleChange,
    reservationNumber,
    originAirport,
    destinationAirport,
    lastName,
    totalCost,
    numberOfGuests,
    tourOperator,
    lengthOfStay,
    agentEmail,
    handleChange1,
    handleChange2,
    handleChangeTourOperator,
  } = props;

  const req = ' *';
  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  let email = '';
  if (params.get('email')) {
    email = params.get('email');
  }

  const tourOperatorsUk = [
    'Audley',
    'Canadian Affair',
    'First Class Holidays',
    'Gold Medal',
    'NATS',
    'Prestige Holidays',
    'Premier Holidays',
    'Other',
  ];

  const tourOperatorsAus = [
    'Adventure World',
    'Entire Travel Group',
    'Ski Max',
    "Sno'N'Ski",
    'APT/Travelmarvel',
    'Scenic/Emerald',
    'Viva Holidays',
    'Momento Travel',
    'Adventure Destinations',
    'Globus Family of Brands',
    'Inspiring Vacations',
    "The Travel Corporation 'Trafalgar/Contiki/Insight Vacations",
    "Other",
  ];

  const tourOperatorsFr = [
    'AmériGo',
    "Caractères d'Amériques",
    'Fram',
    'Jet Set',
    'Kuini',
    'Naar',
    'Salaun Holidays',
    'TUI',
    'Visiteurs',
    'Voyamar',
    'Worldia',
    'Discovery Trains',
    'Autre',
  ];

  const tourOperatorsDe = [
    'America Unlimited',
    'Canusa Touristik',
    'CRD Touristik',
    'Dertour',
    'SK Touristik',
    'TUI',
    'Windrose',
    ' Anderer',
  ];

  const defaultTourOperators = [
    'Adventure World (The Travel Corp)',
    'Air Canada Vacations',
    'Alaska Airlines Vacations',
    'Allegiant Airlines',
    'American Airlines Vacations',
    'Apple Vacations',
    'APT',
    'Bedsonline',
    'Costco',
    'Delta Vacations',
    'Direct with Hotel',
    'Expedia Australia',
    'Expedia TAAP',
    'First Travel Group',
    'Flight Centre Group',
    'Frontier Airlines',
    'Funjet Vacations',
    'GDS',
    'Go Global Travel',
    'Go Holidays/Helloworld NZ',
    'GoGo Worldwide Vacations',
    'Helloworld Australia / Viva Holidays',
    'Hoot Holidays (House of Travel)',
    'JetBlue Vacations',
    'Journese',
    'Luxury Escapes',
    'Mastercard',
    'Pleasant Holidays',
    'Qantas Holidays',
    'Skylink',
    'Southwest Vacations',
    'Spirit Vacations',
    'Sun Country Vacations',
    'Sunquest',
    'Vacations Hawaii',
    'Webjet Limited',
    'Westjet Vacations',
    'Other',
  ];

  const countryOperatorsMap = {
    gb: tourOperatorsUk,
    au: tourOperatorsAus,
    de: tourOperatorsDe,
    fr: tourOperatorsFr,
  };

  const tourOperators = countryOperatorsMap[selectedCountry] || [];

  useEffect(() => {
    const checkCountry = async () => {
      const langData = await StorageHandler.load(storageKeys.lang);
      const countryCode = langData?.code?.toLowerCase();
      setSelectedCountry(countryCode);

      setIsUk(countryCode === 'gb');
      setIsAus(countryCode === 'au');
      setIsFr(countryCode === 'fr');
      setIsDe(countryCode === 'de');

      setSelectedTourOperators([]);
    };

    checkCountry();
  }, []);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    let updatedSelection;
    if (checked) {
      updatedSelection = [...selectedTourOperators, value];
    } else {
      updatedSelection = selectedTourOperators.filter((item) => item !== value);
    }

    setSelectedTourOperators(updatedSelection);
    handleChangeTourOperator({ value: updatedSelection });
  };

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const accommodationOptions = [
    { value: 'Alberta', label: 'Alberta' },
    { value: 'British Columbia', label: 'British Columbia' },
    { value: 'Manitoba', label: 'Manitoba' },
    { value: 'New Brunswick', label: 'New Brunswick' },
    { value: 'Newfoundland and Labrador', label: 'Newfoundland and Labrador' },
    { value: 'Northwest Territories', label: 'Northwest Territories' },
    { value: 'Nova Scotia', label: 'Nova Scotia' },
    { value: 'Nunavut', label: 'Nunavut' },
    { value: 'Ontario', label: 'Ontario' },
    { value: 'Prince Edward Island', label: 'Prince Edward Island' },
    { value: 'Quebec', label: 'Quebec' },
    { value: 'Saskatchewan', label: 'Saskatchewan' },
    { value: 'Yukon', label: 'Yukon' },
  ];

  return (
    <div className="contentContainer BookingForm">
      <div className="header">
        <h1>{i18n.translate('rewards.bookingForm.title')}</h1>
      </div>
      <hr />
      <div className="body">
        <form method="post" id="formRewards">
          <h3>{i18n.translate('rewards.bookingForm.subTitle')}</h3>
          <hr className="subline" />

          <div className="grid userInfo">
            {agentFirstName} {agentLastName}
            <br />
            {agentCompany}
            <br />
            {agentCity}
            {postalCode && ', '} {postalCode}
            <br />
            {agentCountry}
            <br />
            <br />
            <a onClick={openFancybox}>{i18n.translate('rewards.bookingForm.editInfo')}</a>
          </div>
          <hr />
          <br />
          <br />
          <h4>{i18n.translate('rewards.bookingForm.sub2')}</h4>
          <p className="required">{i18n.translate('rewards.bookingForm.required')}</p>
          <div className="grid">
            <div className="item medium">
              <label htmlFor="tourOperator">
                {i18n.translate('rewards.bookingForm.tourOperator').concat(req)}
                <select name="tourOperator" value={tourOperator} onChange={handleChange} required>
                  <option>{i18n.translate('rewards.bookingForm.select')}</option>
                  {isUk || isAus || isFr || isDe
                    ? tourOperators.map((operator) => (
                      <option key={operator} value={operator}>
                        {operator}
                      </option>
                    ))
                    : defaultTourOperators.map((operator) => (
                      <option key={operator} value={operator}>
                        {operator}
                      </option>
                    ))}
                </select>
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="reservationNumber">
                {i18n.translate('rewards.bookingForm.bookingNumber').concat(req)}
                <input
                  name="reservationNumber"
                  value={reservationNumber}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.bookingNumber')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="accomodationName">
                {i18n.translate('rewards.bookingForm.provinceVisited').concat(req)}
                <Select
                  isMulti
                  name="accomodationName"
                  options={accommodationOptions}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder={i18n.translate('rewards.bookingForm.select')}
                  value={selectedAccommodations.map((accom) => ({ value: accom, label: accom }))}
                  onChange={(selectedOptions) => {
                    const values = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                    setSelectedAccommodations(values);
                    handleChange({ target: { name: 'accomodationName', value: values.join(', ') } });
                  }}
                  isSearchable
                  closeMenuOnSelect={false}
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: '100%',
                    }),
                    control: (base) => ({
                      ...base,
                      width: '100%',
                    }),
                  }}
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="numberOfGuests">
                {i18n.translate('rewards.bookingForm.pax').concat(req)}
                <input
                  name="numberOfGuests"
                  value={numberOfGuests}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.pax')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="arrivalDate">
                {i18n.translate('rewards.bookingForm.arrivalDate').concat(req)}
                <input
                  type="date"
                  name="arrivalDate"
                  className="DatePicker"
                  onChange={handleChange2}
                  value={arrivalDate}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="departureDate">
                {i18n.translate('rewards.bookingForm.departureDate').concat(req)}
                <input
                  type="date"
                  name="departureDate"
                  className="DatePicker"
                  onChange={handleChange1}
                  value={departureDate}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="lengthOfStay">
                {i18n.translate('rewards.bookingForm.lengthOfStay').concat(req)}

                <input
                  name="lengthOfStay"
                  value={lengthOfStay}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.lengthOfStay')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="cost">
                {i18n.translate('rewards.bookingForm.cost').concat(req)}
                <div className="cost">
                  <div className="dollarSign">$</div>
                  <input
                    name="totalCost"
                    value={totalCost}
                    onChange={handleChange}
                    placeholder={i18n.translate('rewards.bookingForm.cost')}
                    required
                  />
                </div>
              </label>
            </div>

            {fileUrl === null && (
              <div className="item large">
                <label htmlFor="file">{i18n.translate('rewards.bookingForm.file')}</label>
                <DropZone />
              </div>
            )}
            {fileUrl !== null && (
              <div className="item large success">
                <label htmlFor="file">{i18n.translate('rewards.bookingForm.file')}</label>
                <div className="file">
                  <div className="fileIcon">
                    <FontAwesomeIcon icon={['fas', 'check-circle']} />
                    <p>File has been uploaded successfully</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <br />
          <hr />
          <div className="buttonHolder">
            <button type="submit" className="btn submit" onClick={submitForm}>
              {i18n.translate('rewards.bookingForm.button')}
            </button>
          </div>
        </form>
      </div>

      {showIframe && (
        <div className="iframe">
          <div
            className="bgIframe"
            onClick={() => {
              closeIframe();
            }}
          />
          <div className="iframeHolder">
            <div
              className="closeIframe"
              href="#"
              onClick={() => {
                closeIframe();
              }}
            >
              <span className="closeText">
                <FontAwesomeIcon icon={['fas', 'chevron-left']} /> {i18n.translate('general.back')}
              </span>
            </div>
            <div className="contentIframe">
              <iframe
                width="100%"
                height="100%"
                id="iframeModal"
                src={`https://accounts.travpromobile.com/profile/?header=false&email=${agentEmail}&app_id=633`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

BookingForm.propTypes = {
  submitForm: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChange1: PropTypes.func.isRequired,
  handleChange2: PropTypes.func.isRequired,
  handleChange3: PropTypes.func.isRequired,
  handleChangeFile: PropTypes.func.isRequired,
  typeOfTrip: PropTypes.string.isRequired,
  arrivalDate: PropTypes.string.isRequired,
  originAirport: PropTypes.string.isRequired,
  confirmNumber: PropTypes.string.isRequired,
  birthday: PropTypes.string.isRequired,
  departureDate: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  destinationAirport: PropTypes.string.isRequired,
  file: PropTypes.func.isRequired,
  cost: PropTypes.string.isRequired,
  tourOperator: PropTypes.string.isRequired,
  lengthOfStay: PropTypes.number.isRequired,
  agentEmail: PropTypes.string.isRequired,
  agentFirstName: PropTypes.string.isRequired,
  agentLastName: PropTypes.string.isRequired,
  agentCompany: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  agentCity: PropTypes.string.isRequired,
  agentCountry: PropTypes.string.isRequired,
  agentId: PropTypes.string.isRequired,
  files: PropTypes.string.isRequired,
  numberOfGuests: PropTypes.string.isRequired,
  reservationNumber: PropTypes.string.isRequired,
  accomodationName: PropTypes.string.isRequired,
};

export default BookingForm;
